import { Subject } from "rxjs";
import { Injectable, InjectionToken } from "@angular/core";

export const DATA_TRANSFER_HELPER = new InjectionToken<DataTransfer>('[Value] DataTransfer');

@Injectable({providedIn: 'root'})
export class DataTransfer {
  static data: boolean
  transfer: Subject<boolean> = new Subject<boolean>();

  setData(value: boolean): void {
    DataTransfer.data = value
    this.transfer.next(DataTransfer.data);
  }

}


